import {
  NavBarBody,
  NavBarFooterProfile,
  NavProvider,
} from '@airship-platform/airship-patterns';
import { Outlet } from 'react-router';
import { useOfflineDbLogoutWipe } from './data-offline/rxdb/utils/OfflineDbProvider';

const NavBarFooter: React.FC = () => {
  const wipeForLogout = useOfflineDbLogoutWipe();

  return <NavBarFooterProfile onLogoutClick={wipeForLogout} />;
};

const App: React.FC = () => (
  <NavProvider navbarBody={<NavBarBody />} footerNode={<NavBarFooter />}>
    <Outlet />
  </NavProvider>
);

export default App;
